<script setup lang="ts">
import { PropType } from 'vue'
import FullProduct from '~/models/Product/FullProduct'

const props = defineProps({
    product: {
        type: Object as PropType<FullProduct>,
        required: true,
    },
})

const price = props.product.mobileAppPrice || props.product.mobileAppPriceForLoggedInUser

const useMobileAppPrice = () => {
    useNuxtApp().$bus.$emit('showMigrateToMobileAppModal', props.product)
}
</script>

<template>
    <div class="price-mobile-app__container">
        <button class="btn price-mobile-app__button" @click="useMobileAppPrice">
            <span v-if="product.mobileAppPrice || product.mobileAppPriceForLoggedInUser">{{
                $t('productDetail.mobileAppPrice.ctaPrice')
            }}</span>
            <span v-else-if="product.mobileAppAction">{{ $t('productDetail.mobileAppPrice.cta') }}</span>
        </button>
        <div class="price-mobile-app__description">
            <template v-if="product.mobileAppPrice || product.mobileAppPriceForLoggedInUser">
                <span class="price-mobile-app__price notranslate" v-html="$formatCurrency(price)"></span>
                {{ $t('productDetail.mobileAppPrice.description') }}
            </template>
            <template v-else-if="product.mobileAppAction">
                {{ product.mobileAppAction.title }}
            </template>
        </div>
    </div>
</template>

<style scoped lang="scss">
.price-mobile-app {
    &__container {
        font-size: 13px;
        border-radius: 10px;
        margin-top: 5px;
        margin-bottom: 10px;
        line-height: 25px;
        background: $color-cta-header-light;
        padding: 10px 1em;

        @include screen-md {
            align-items: stretch;
        }
    }

    &__button {
        display: flex;
        justify-items: center;
        justify-content: center;
        border: 1px solid $color-cta;
        color: $color-cta;
        border-radius: 100px;
        font-size: 14px;
        line-height: 19px;
        min-width: 220px;
        min-height: 38px;

        &:hover,
        &:focus {
            color: $color-white;
            background: $color-cta;

            .discount-ico {
                background: url(/nuxt-assets/icons/percentage-white.svg) no-repeat 50%;
            }
        }
    }

    &__description {
        font-size: 18px;
        font-weight: 700;
        margin-top: 10px;
        align-items: center;

        .info-ico {
            margin-left: 8px;
            width: 12px;
            height: 12px;
            display: inline-block;
            background: url(/nuxt-assets/icons/info-grey.svg) no-repeat 50%;
            background-size: 100% 100%;
        }
    }

    &__price {
        color: $color-cta;
        font-size: 26px;
        font-weight: 700;
    }
}
</style>
